import { supportRequestsRestHooks } from '../store/SupportRequests/SupportRequestsSlice';

const useSupportRequests = () => {
  const { loadSupportRequest, updateSupportRequest } =
    supportRequestsRestHooks.use();

  const updateAndReloadRequest = async (params) => {
    const { id, supportRequest } = params;
    await updateSupportRequest(id, supportRequest);
    loadSupportRequest(id);
  };

  return {
    updateAndReloadRequest,
  };
};

export default useSupportRequests;
